import {DLSelectMultiValueRemove} from '@wallaby-ui/core';
import * as React from 'react';

import FilterNodeRemoveButton from './FilterNodeRemoveButton';

const FilterNodeSelectRemoveItem = (props) => (
  <DLSelectMultiValueRemove {...props}>
    {(innerProps) => (
      <FilterNodeRemoveButton removeFilter={innerProps.onClick} />
    )}
  </DLSelectMultiValueRemove>
);

export default FilterNodeSelectRemoveItem;
